import HmEventRegistry from './../model/HmEventRegistry';
import NativeAjax from './../util/NativeAjax';
import UrlManager from './../model/UrlManager';

var NetChecker = function(){

	const url = "/maintenance/netcheck.json";

	const SLOW_INTERVAL = 1;

	/**
	* Frequent triggering of this event might lead to a wrong impression.
	* and hence, TRIGGER_INTERVAL which decides when this event is eligible to be triggered again.
	*/
	const TRIGGER_INTERVAL = (window.net_checks && !isNaN(window.net_checks.interval)) ? window.net_checks.interval : 3;
	
	var requestTime = 0;

	var success = (resp, req) => {
		if(resp && resp.success){
			var timeTaken = Math.round(new Date().getTime()/1000) - requestTime;
			if(timeTaken > SLOW_INTERVAL){
				if(!window.net_checks || (window.net_checks && window.net_checks["slow"])){
					HmEventRegistry.fireEvent("POST_NET_CHECK");
					HmEventRegistry.fireEvent("SLOW_NET_2");
				}
			}
		}else if(req && req.status === 200){
			console.warn("SEVERE: NetCheck json is not configured");
		}else{
			failure(resp,req);
		}		
	};

	var failure = (resp, req) => {
		if(!window.net_checks || (window.net_checks && window.net_checks["no"])){
			HmEventRegistry.fireEvent("NO_INTERNET");
			HmEventRegistry.fireEvent("NO_NET_2");
		}		
	};

	let triggerEligible = function(){
		var currTime = Math.round(new Date().getTime()/1000);
		
		return ((currTime - requestTime) > TRIGGER_INTERVAL);
	};


	return{
		init:function(){
			if(url && triggerEligible()){
				requestTime = Math.round(new Date().getTime()/1000);
				new NativeAjax(url/*+"?ver="+window.fileVersion*/).enableCORS().get(success, failure);
			}
		}
	};
}();

export default NetChecker;

HmEventRegistry.registerEvent("NET_CHECK",function(){
	if(!window.net_checks || (window.net_checks && (window.net_checks["no"]  || window.net_checks["slow"]))){
		NetChecker.init();
	}	
});

HmEventRegistry.registerEvent("POST_NET_CHECK", function(){
	console.warn("NetCheck: Network seems to be slow");
});

HmEventRegistry.registerEvent("NO_INTERNET", function(){
	console.warn("NetCheck: NO Internet.");	
});



// WEBPACK FOOTER //
// ./src/hmevents/NetChecker.js